import { Divider, Grid, Typography } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SiNoChip } from "src/pages/sistema/components/FieldView";
import { dateFormatter } from "src/utils/formatters";
import { OperacionADCMFields } from '../types/fields';
import { OperacionADCM } from "../types/types";
import { ADCMClienteTipo } from "../types/enum";

type SeccionADCMDatosOperacionProps = {
  operacion: OperacionADCM;
}

const SeccionADCMDatosOperacion = ({ operacion }: SeccionADCMDatosOperacionProps) => {
  return (
    <CardActions title='Datos Operación' icon='mdi:briefcase-outline' colapsable>
      <Grid container spacing={2.5} rowSpacing={2.5}>

        {/* Organización */}
        <Grid item xs={12} md={3}>
          <FieldView label='País' value={operacion[OperacionADCMFields.NombrePais]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Unidad de Negocio' value={operacion[OperacionADCMFields.UnidadNegocio]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Equipo Comercial' value={operacion[OperacionADCMFields.SectorComercial]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView
            label='Fecha Solicitud'
            value={operacion[OperacionADCMFields.FechaSolicitud]
              ? dateFormatter.toShortDate(operacion[OperacionADCMFields.FechaSolicitud])
              : undefined}
          />
        </Grid>

        {/* Emisor */}
        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Emisor
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12} md={3}>
          <FieldView label='Razón Social' value={operacion[OperacionADCMFields.RazonSocialEmisor]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Tipo Emisor' value={operacion[OperacionADCMFields.DescEmisorTipo]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Prospecto o Cliente' value={operacion[OperacionADCMFields.DescClienteTipo]} />
        </Grid>
        {operacion[OperacionADCMFields.CodVirtualCliente] === ADCMClienteTipo.Cliente && (
          <Grid item xs={12} md={3}>
            <FieldView label='Nro. Cuenta' value={operacion[OperacionADCMFields.NroCuenta]} />
          </Grid>
        )}

        {/* Características */}
        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Características
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12} md={3}>
          <FieldView label='Emisor Preaprobado'>
            <SiNoChip value={operacion[OperacionADCMFields.EmisorPreaprobado]} />
          </FieldView>
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Rating Crediticio Emisor' value={operacion[OperacionADCMFields.RatingCrediticioEmisor]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Legislación' value={operacion[OperacionADCMFields.Legislacion]} />
        </Grid>

        {/* Tipo de operación */}
        <Grid item xs={12}>
          <Divider textAlign='left'>
            <Typography variant='caption' color='text.secondary' sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Tipo de operación
            </Typography>
          </Divider>
        </Grid>

        <Grid item xs={12} md={3}>
          <FieldView label='Tipo Transacción' value={operacion[OperacionADCMFields.DescTransaccionTipo]} />
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Underwriting'>
            <SiNoChip value={operacion[OperacionADCMFields.Underwriting]} />
          </FieldView>
        </Grid>
        <Grid item xs={12} md={3}>
          <FieldView label='Bridgeloan'>
            <SiNoChip value={operacion[OperacionADCMFields.Bridgeloan]} />
          </FieldView>
        </Grid>

      </Grid>
    </CardActions>
  );
}

export default SeccionADCMDatosOperacion;
